import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager/actions'
import { put, select } from 'redux-saga/effects'

export function* refetchProjectAccessSaga() {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (!projectId) {
    return
  }

  yield put(managerActions.fetchProjectSaga({ id: projectId, silent: true }))
}
